import React from 'react';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { isRequired } from '../../../utils/validation';
import { Country } from '../../../components/Country';
import { Content } from '../../../infrastructure/content';

const CountryDropDown = ({ values }) => (
  <Content>
    {({ accountDetailsFormErrorSelect }) => (
      <Field
        name="countryOther"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <ConditionalPanel isVisible>
            <GenericFieldWrapper
              name="countryOther"
              validationMessage={touched && !!error ? accountDetailsFormErrorSelect : null}
            >
              <Country {...input} values={values} removeCountries={['United Kingdom']} />
            </GenericFieldWrapper>
          </ConditionalPanel>
        )}
      </Field>
    )}
  </Content>
);

export default CountryDropDown;
